export function isObject(item: any): item is Object {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

export function mergeObjects(a: any, b: any): any {
    if (!isObject(a) || !isObject(b)) {
        return a === b ? a : undefined;
    }
    const result = {};
    Object.keys(a).forEach((aKey) => {
        if (!isObject(b[aKey]) && !isObject(a[aKey]) && b[aKey] === a[aKey]) {
            result[aKey] = a[aKey];
        } else if (isObject(a[aKey]) && isObject(b[aKey])) {
            const merged = mergeObjects(a[aKey], b[aKey]);
            if (merged) {
                result[aKey] = merged;
            }
        }
    });
    return result;
}
